"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _customRendererPropTypes = _interopRequireDefault(require("../helpers/customRendererPropTypes"));

var _iconCaret = _interopRequireDefault(require("../../../icons/icon-caret.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CustomDropdownRenderer = function customDropdownRenderer(_ref) {
  var storedValue = _ref.storedValue,
      fieldData = _ref.fieldData,
      eventHandler = _ref.eventHandler,
      isValid = _ref.isValid,
      complete = _ref.complete;
  var fieldKey = fieldData.fieldKey,
      label = fieldData.label,
      options = fieldData.options,
      placeholder = fieldData.placeholder;
  var showPlaceholder = placeholder && !storedValue;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "identity-dropdown-input__label",
    htmlFor: fieldKey
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown__wrapper"
  }, showPlaceholder && /*#__PURE__*/_react["default"].createElement("span", {
    className: "dropdown__label"
  }, placeholder), /*#__PURE__*/_react["default"].createElement("select", {
    className: "dropdown survey-form__dropdown",
    id: fieldKey,
    name: fieldKey,
    onChange: function onChange(event) {
      return eventHandler.handleUpdate(event);
    },
    defaultValue: storedValue,
    required: fieldData.validation.required
  }, showPlaceholder && /*#__PURE__*/_react["default"].createElement("option", {
    value: ""
  }), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  })), /*#__PURE__*/_react["default"].createElement(_iconCaret["default"], {
    className: "dropdown__icon"
  })), !isValid && complete && /*#__PURE__*/_react["default"].createElement("span", {
    className: "select-input-control__error"
  }, fieldData.validation.message));
};

CustomDropdownRenderer.propTypes = _customRendererPropTypes["default"];
var _default = CustomDropdownRenderer;
exports["default"] = _default;